export default class AbstractChannel {

  readonly name: string = 'unknown'
  readonly title: string = 'unknown'
  readonly titleShort: string = 'unknown'
  readonly isParcsChannel: boolean = false

  /**
   * To date, channel colors have been taken from the "tab20" color scheme
   * shown here:
   * 
   * https://matplotlib.org/stable/users/explain/colors/colormaps.html#qualitative

   * All 20 have now been used, and we're pretty much at the limit of what the
   * human eye can easily distinguish. If we need to add more channels, then
   * we may need to take a step back and rethink how we're approaching this.
   */
  readonly color: string = '#787878'

  readonly supportedFeatures: string[] = []

  /**
   * Returns true if this channel supports all of the specified features.
   */
  supports(features: string[]): boolean {
    return features.every((feature) => {
      return this.supportedFeatures.includes(feature)
    })
  }

}
